import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useShallow } from 'zustand/react/shallow';
import { IService } from '@clickersphere/core/entities/IService';
import { useDeleteService } from '../../../../app/hooks/service/useDeleteService';
import { useDetachServiceFromPackages } from '../../../../app/hooks/service/useDetachServiceFromPackages';
import useToast from '../../../../app/hooks/useToast';
import { useStore } from '../../../../app/store';

interface IUseDeleteServiceConflictModalController {
  service: IService;
}

export function useDeleteServiceConflictModalController({
  service,
}: IUseDeleteServiceConflictModalController) {
  const [isProcessing, setIsProcessing] = useState(false);
  const { toast } = useToast();
  const { t } = useTranslation();

  const { handleCloseModal } = useStore(
    useShallow((state) => ({
      handleCloseModal: state.modal.handleCloseModal,
    })),
  );

  const { detachServiceAsync } = useDetachServiceFromPackages();
  const { deleteServiceAsync } = useDeleteService();

  async function handleConfirm() {
    setIsProcessing(true);
    try {
      await detachServiceAsync(service.id);
      await deleteServiceAsync(service.id);
      handleCloseModal();
    } catch {
      toast(t('catalog.form.actions.saveError'), 'error');
    } finally {
      setIsProcessing(false);
    }
  }

  return {
    isProcessing,
    handleConfirm,
    handleCancel: handleCloseModal,
  };
}
